import { Link } from "react-router-dom";
import "bootstrap-icons/font/bootstrap-icons.css";

export default function EmptyListState({
    icon = "emoji-frown",
    message,
    actionLabel,
    actionTo,
    actionIcon = "plus-lg",
    className = "",
}) {
    const showAction = Boolean(actionLabel && actionTo);

    return (
        <div
            className={`rounded-xl border border-dashed border-slate-200 bg-neutral-100/60 px-6 py-12 text-center ${className}`.trim()}
        >
            <i
                className={`bi bi-${icon} mb-3 block text-4xl text-slate-300 md:text-5xl`}
                aria-hidden
            />
            <p className="mb-0 text-sm text-slate-500">{message}</p>
            {showAction ? (
                <Link
                    to={actionTo}
                    className="btn btn-primary-app mt-5 inline-flex items-center gap-2 font-semibold"
                >
                    <i className={`bi bi-${actionIcon}`} aria-hidden />
                    {actionLabel}
                </Link>
            ) : null}
        </div>
    );
}
